// Copyright (c) Ping. All rights reserved.
//
// Live count of unread activity items, for the chat-header bell badge. Reuses
// the same client-derived feed subscription the Activity screen consumes, so
// the badge stays consistent with the feed (and updates live as items arrive /
// are marked read across the user's devices).

import { useEffect, useState } from 'react';

import { subscribeActivityFeed } from './activityFeed';

export function useActivityUnreadCount(): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const unsubscribe = subscribeActivityFeed('all', 'mostRecent', (items) => {
      setCount(items.reduce((n, it) => n + (it.unread ? 1 : 0), 0));
    });
    return unsubscribe;
  }, []);
  return count;
}
